import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { fetchOnboardingPages } from '../../../business/onboarding';

const OnboardingPagesContext = createContext({
  pages: [],
  hasOnboardingPages: false,
  refetchPages: () => {}
});

export const OnboardingPagesProvider = ({ children }) => {
  const [pages, setPages] = useState([]);

  const loadPages = useCallback(async () => {
    const result = await fetchOnboardingPages();
    setPages(result);
  }, []);

  useEffect(() => {
    loadPages();
  }, [loadPages]);

  return (
    <OnboardingPagesContext.Provider
      value={{
        pages,
        hasOnboardingPages: pages.length > 0,
        refetchPages: loadPages
      }}
    >
      {children}
    </OnboardingPagesContext.Provider>
  );
};

export const useOnboardingPages = () => useContext(OnboardingPagesContext);

export default OnboardingPagesContext;
